import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {AfterContentInit, AfterViewChecked, Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {FormControl} from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import {EmailTemplateModel} from '../../../models/EmailTemplateModel';
import {User} from '../../../models/User';
import {UserModel} from '../../../models/UserModel';

@Component({
  selector: 'app-chips-autocomplete',
  templateUrl: './chips-autocomplete.component.html',
  styleUrls: ['./chips-autocomplete.component.scss']
})
export class ChipsAutocompleteComponent implements OnInit, OnChanges {

  @Input() templateList: EmailTemplateModel[];
  @Input() mailingList: UserModel[];
  @Input() template: EmailTemplateModel;
  @Input() templateIndex: number;

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;

  separatorKeysCodes = [ENTER, COMMA];

  userCtrl = new FormControl();

  filteredUsers: Observable<any[]>;

  selectedUserList = [];

  @ViewChild('userInput', { static: true }) userInput: ElementRef;

  constructor() {
    // this.filteredUsers = this.userCtrl.valueChanges.pipe(
    //   startWith(null),
    //   map((user: string | null) => user ? this.filter(user) : this.mailingList.slice()));
  }

  ngOnInit(): void {
    // this.templateList$.subscribe(res => {
    //   console.log('emailform chips:      ', res);
    //   this.mailingList = res[this.templateIndex].mailingList;
    //   if (this.mailingList) {
    //     this.filteredUsers = this.userCtrl.valueChanges.pipe(
    //       startWith(null),
    //       map((user: string | null) => user ? this.filter(user) : this.mailingList.slice()));
      // }
    // });
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;

    // Add our user
    if ((value || '').trim()) {
      this.selectedUserList.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }

    this.userCtrl.setValue(null);
  }

  remove(user: any): void {
    const index = this.selectedUserList.indexOf(user);

    if (index >= 0) {
      this.selectedUserList.splice(index, 1);
    }
  }

  filter(x: String | UserModel) {
    return this.mailingList.filter(user =>
      user.mail.toLowerCase().includes((typeof x === 'string') ? x.toLowerCase() : ''));
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    // this.selectedUserList.push(event.option.viewValue);
    this.selectedUserList.push(this.userCtrl.value);
    this.userInput.nativeElement.value = '';
    this.userCtrl.setValue(null);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('mailingList' in changes) {
      if (this.mailingList && !this.filteredUsers) {
        this.filteredUsers = this.userCtrl.valueChanges.pipe(
          startWith(null),
          map((user: string | null) => user ? this.filter(user) : this.mailingList.slice()));
      }
    }
    if ('template' in changes) {
      this.selectedUserList = this.template.userListByTemplate;
    }
  }
}
